import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Box,
  Button,
  Card,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Snackbar,
  TextField,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import React, { useCallback, useEffect, useState } from "react";
import { Form, InputGroup } from "react-bootstrap";
import TransactionTable from "../components/TransactionTable";
import LoadingIcon from "../components/LoadingIcon";
import axios from "axios";

const columns = [
  {
    name: "Amount",
    selector: (row) => (
      <div className={`text-green-600`}>
        + ${parseInt(row.amount).toFixed(2)}
      </div>
    ),
    sortable: true,
  },
  {
    name: "Date",
    selector: (row) => new Date(row.createdAt).toDateString(),
    sortable: true,
  },
];

const Deposit = () => {
  const [depositOption, setDepositOption] = React.useState("");
  const [amount, setAmount] = React.useState("");
  const [transactionID, setTransactionID] = React.useState("");
  const token = localStorage.getItem("token");
  const [notificationType, setNotificationType] = useState("success");
  const [message, setMessage] = useState("");
  const [wallet, setWallet] = useState("");
  const [file, setFile] = useState(null);
  const [showNotification, setShowNotification] = useState(false);
  const vertical = "top";
  const horizontal = "center";

  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);

  const options = {
    headers: { token: token },
  };
  const handleSelectFile = (e) => setFile(e.target.files[0]);

  const getActivity = useCallback(async () => {
    setPageLoading(true);
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}activity/deposit`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          token,
        },
      }
    );

    const data = await response.json();

    if (data.status) {
      setTransactions(data.userTransactions);
    }
    setWallet("bc1qdj35cntspm3rvrscrur5trmwlz4ghnqe3fgvz9");
    setPageLoading(false);
  }, [token]);

  useEffect(() => {
    getActivity();
  }, [getActivity]);

  const handleChange = (event) => {
    setDepositOption(event.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const response = await fetch(`${process.env.REACT_APP_API_URL}deposit`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        token,
      },
      body: JSON.stringify({
        amount,
        depositOption,
        transactionID,
      }),
    });

    const data1 = new FormData();
    data1.append("my_file", file);

    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}upload`,
      data1,
      options
    );
    console.log(res);

    const data = await response.json();

    if (data.status) {
      setAmount("");
      setTransactionID("");
      setShowNotification(true);
      setNotificationType("success");
      setMessage("Your deposit will be made available after confirmation");
      getActivity()
    } else {
      setShowNotification(true);
      setNotificationType("error");
      setMessage("Oops! An Error occured. Try again later");
    }
    setLoading(false);
    setTimeout(() => setShowNotification(false), 4000);
  };
  return (
    <div>
      <div className="mb-9">
        <h3 className="font-bold text-2xl text-white">Deposit</h3>
      </div>
      {pageLoading ? (
        <div className="h-screen flex items-center justify-center">
          <LoadingIcon />
        </div>
      ) : (
        <>
          <Snackbar
            open={showNotification}
            autoHideDuration={6000}
            anchorOrigin={{ vertical, horizontal }}
          >
            <Alert message={message} severity={notificationType}>
              {message}
            </Alert>
          </Snackbar>
          <div className="md:flex mb-9">
            <div className="p-3 w-full border-0">
              <div className="mb-4">
                <h3 className="text-lg text-white">Payment Methods</h3>
              </div>
              <Accordion className="!bg-[#1B4242]">
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  className="bg-[#1B4242]"
                >
                  <Typography className="text-white">
                    Bitcoin Payment Method
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <InputGroup className="mb-3">
                    <Form.Control
                      type="text"
                      placeholder="Disabled input"
                      aria-label="Disabled input example"
                      disabled
                      value={wallet}
                      readOnly
                    />
                    <Button
                      variant="contained"
                      className="!bg-[#101010]"
                      id="button-addon2"
                      onClick={() => {
                        setShowNotification(true);
                        navigator.clipboard.writeText(wallet);
                        setNotificationType("success");
                        setMessage("Wallet address Copied!");
                        setTimeout(() => setShowNotification(false), 4000);
                      }}
                    >
                      Copy
                    </Button>
                  </InputGroup>
                  <img src="/btc.jpeg" className="mt-4" alt="bitcoin" />
                </AccordionDetails>
              </Accordion>
            </div>
            <div className="mx-2 mb-8"></div>
            <form className="w-full" onSubmit={handleSubmit}>
              <Card
                variant="outlined"
                className="p-3 w-full !border-0 !bg-[#1B4242]"
              >
                <div className="mb-4 text-white">
                  <h3 className="text-lg">Submit Notification for Deposit</h3>
                </div>
                <div className="italic mb-8 text-white">
                  <p className="m-0">
                    To deposit, please choose the payment method at the Payment
                    Methods panel and make the payment.
                  </p>
                  <p className="m-0">
                    After completing the payment come back here and fill the
                    deposit notification form.
                  </p>
                </div>
                <Box sx={{ minWidth: 120, marginBottom: 3, color: "white" }}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label" sx={{ color: "white" }}>
                      Select Payment Method
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={depositOption}
                      label="Select Payment Method"
                      onChange={handleChange}
                      sx={{ ".css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input": { color: "white !important" } }}
                      required
                    >
                      <MenuItem value={"btc"}>Bitcoin</MenuItem>
                      <MenuItem value={"USDT"}>USDT</MenuItem>
                      <MenuItem value={"Bank"}>Bank</MenuItem>
                      <MenuItem value={"Paypal"}>Paypal</MenuItem>
                      <MenuItem value={"Gift Cards"}>Gift cards</MenuItem>
                    </Select>
                  </FormControl>
                </Box>
                {
                  depositOption === "btc" ? <>

                    <div className="mb-8">
                      <TextField
                        sx={{
                          '.css-mqt2s5': {
                            color: 'white !important',
                          },
                          '.css-zrqpq1': {
                            color: 'white !important',
                          }
                        }}
                        id="standard-basic"
                        className="w-full"
                        label="Enter Amount"
                        variant="standard"
                        type="number"
                        required
                        value={amount}
                        onChange={(e) => setAmount(e.target.value)}
                      />
                    </div>

                    <TextField
                      sx={{
                        '.css-mqt2s5': {
                          color: "white !important"
                        },
                        '.css-zrqpq1': {
                          color: "white !important"
                        }
                      }}
                      id="standard-basic"
                      className="w-full"
                      label="Enter Transaction ID"
                      variant="standard"
                      required
                      value={transactionID}
                      onChange={(e) => setTransactionID(e.target.value)}
                    />
                    <div className="my-2">
                      <input
                        id="file"
                        type="file"
                        accept="image/*"
                        required
                        onChange={handleSelectFile}
                        multiple={false}
                      />
                    </div>
                    <div className="text-red-600 font-bold text-sm italic text-center mb-10">
                      Upload Transaction Receipt
                    </div>
                  </> : <p className="text-white">{`Contact Support to make a deposit using ${depositOption}`}</p>
                }

                <div className="mt-8">
                  {loading ? (
                    <Button className="w-full">
                      <LoadingIcon />
                    </Button>
                  ) : (
                    <Button
                      className="w-full !bg-[#101010]"
                      variant="contained"
                      type="submit"
                    >
                      Notify for Deposit
                    </Button>
                  )}
                </div>
              </Card>
            </form>
          </div>
          <div className="mb-9">
            <h6 className="font-bold text-2xl text-center text-white">
              Deposit History
            </h6>
          </div>
          <TransactionTable columns={columns} transactions={transactions} />
        </>
      )}
    </div>
  );
};

export default Deposit;
